import React, {useCallback, useState, useEffect} from 'react'
import PropTypes from 'prop-types'
import debounce from 'lodash/debounce'

export const HeaderContext = React.createContext()
export const HeaderProvider = ({children}) => {
    const [scrollY, setScrollY] = useState(0)
    const [shrunken, setShrunken] = useState(false)
    // vertical scroll position from which on the header should shrink
    const unshrinkOffset = 0
    const shrinkOffset = 50

    const handleScroll = useCallback(
        debounce(() => {
            setScrollY(window.scrollY)
        }, 55),
        []
    )

    useEffect(() => {
        window.addEventListener('scroll', handleScroll, {passive: true})
        return () => {
            window.removeEventListener('scroll', handleScroll)
        }
    }, [])

    useEffect(() => {
        if (shrunken) {
            setShrunken(scrollY > unshrinkOffset)
        } else {
            setShrunken(scrollY > shrinkOffset)
        }
    }, [scrollY])

    return <HeaderContext.Provider value={{shrunken}}>{children}</HeaderContext.Provider>
}

HeaderProvider.propTypes = {
    children: PropTypes.node.isRequired
}
